// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper___30mKu","component":"component___hnKA3","loading":"loading____RIVP"};


//////////////////
// WEBPACK FOOTER
// /app/scss/App.scss
// module id = 273
// module chunks = 0